import {
  ArrayItem,
  ArrayContainer,
  ChangeItem,
  DateOnlyPicker,
  DatePicker,
  DropDownList,
  MultiLineBox,
  RadioButton,
  StaticText,
  TextBox,
} from 'src/js/containers/auto_layout/components/dynamic';

export const ARRAY_COMPONENT_ID = 'datlowe.layout.primitives.array';

// need to be a function because of circular dependencies
export const AUTO_LAYOUT_COMPONENTS_MAP = () => ({
  [ARRAY_COMPONENT_ID]: {component: ArrayContainer},
  'datlowe.layout.object.change': {component: ChangeItem, inputComponent: true},
  'datlowe.layout.primitives.text.textBox': {
    component: TextBox,
    inputComponent: true,
  },
  'datlowe.layout.primitives.boolean.checkBox': {
    component: 'dl-layout-check-box',
  },
  'datlowe.layout.primitives.boolean.indeterminateCheckBox': {
    component: 'dl-layout-indeterminate-check-box',
  },
  'datlowe.layout.primitives.date.datePickerBox': {
    component: DatePicker,
    inputComponent: true,
  },
  'datlowe.layout.primitives.date.dateOnlyPickerBox': {
    component: DateOnlyPicker,
    inputComponent: true,
  },
  'datlowe.layout.primitives.number.textNumberBox': {
    component: 'dl-numeric-expression',
  },
  // TODO: Map to dl-combo-box instead dl-drop-box. (Temporary linked.)
  'datlowe.layout.primitives.text.comboBox': {
    component: DropDownList,
    inputComponent: true,
  },
  'datlowe.layout.primitives.text.dropBox': {
    component: DropDownList,
    inputComponent: true,
  },
  'datlowe.layout.primitives.text.multilineBox': {
    component: MultiLineBox,
    inputComponent: true,
  },
  'datlowe.layout.primitives.text.radio': {
    component: RadioButton,
    inputComponent: true,
  },
  'datlowe.layout.primitives.text.static': {
    component: StaticText,
    inputComponent: true,
  },
  'datlowe.layout.primitives.text.summaryStringBox': {
    component: 'dl-summary-string-box',
  },
  'datlowe.layout.pane.mapTags': {component: 'dl-map-tags'},
  'datlowe.layout.pane.outputFormObjectSelector': {
    component: 'dl-output-form-object-selector',
  },
  'datlowe.layout.pane.screenObjectSelectorArray': {
    component: 'dl-screen-object-selector-array',
  },
  'datlowe.layout.pane.textChunk': {component: 'dl-layout-text-chunk'},
  'datlowe.layout.pane.arrayItem': {component: ArrayItem},
  'datlowe.layout.pane.component': {component: 'dl-layout-component'},
});
